import {
  CHANGE_KINDS,
  type ChangeSizes,
  changeKindOf,
  markdownLines,
  type WikiChangeItem,
} from "@esi/shared";
import { t as i18nT } from "../i18n/i18n.ts";

/** "+4 −1": an edit's lines added and removed. */
export const lineSize = (stats: { added: number; removed: number }) =>
  i18nT("wiki.sizes.lines", { added: stats.added, removed: stats.removed });

/**
 * A change set's sizes in the one vocabulary (spec `project-wiki` "Change sizes by kind"):
 * "2 new pages · 1 edit +4 −1 · 2 moves · 1 folder", empty kinds left out.
 */
export function sizesText(sizes: ChangeSizes): string {
  const parts = CHANGE_KINDS.flatMap((kind) => {
    const count = sizes.counts[kind];
    if (!count) {
      return [];
    }
    const label = i18nT(`wiki.sizes.${kind}`, { count });
    return [
      kind === "edits" && sizes.measured
        ? `${label} ${lineSize({ added: sizes.added, removed: sizes.removed })}`
        : label,
    ];
  });
  return parts.length ? parts.join(" · ") : i18nT("wiki.sizes.none");
}

/** One item's size: a new page's lines, an edit's +/−, nothing for the rest. */
export function itemSize(item: Pick<WikiChangeItem, "op" | "markdown" | "stats">): string | null {
  const kind = changeKindOf(item.op);
  if (kind === "created") {
    return i18nT("wiki.sizes.newLines", { count: markdownLines(item.markdown) });
  }
  if (kind === "edits" && item.stats) {
    return lineSize(item.stats);
  }
  return null;
}
